import React from 'react';
import { UnifiedInbox } from '@/components/inbox/UnifiedInbox';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@vaiu/ui/card';
import { Inbox as InboxIcon } from 'lucide-react';
import { i18n } from '@/utils/i18n';

/**
 * InboxPage - Dedicated page for viewing the action inbox
 * Shows all tokens and items requiring user action
 */
const InboxPage: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      {/* Page Header */}
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-2">
          <InboxIcon className="w-8 h-8 text-primary" />
          <h1 className="text-3xl font-bold">{i18n.__('inbox.title')}</h1>
        </div>
        <p className="text-gray-600">
          {i18n.__('inbox.subtitle')}
        </p>
      </div>

      {/* Main Inbox Component - Start expanded on dedicated page */}
      <UnifiedInbox collapsed={false} />

      {/* Help Section */}
      <Card className="mt-8 bg-blue-50/50 border-blue-200">
        <CardHeader>
          <CardTitle className="text-lg">{i18n.__('inbox.aboutTitle')}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-2 text-sm text-gray-600">
          <p>
            • <strong>{i18n.__('inbox.revealedTokens')}</strong>
          </p>
          <p>
            • <strong>{i18n.__('inbox.pendingInvoices')}</strong>
          </p>
          <p>
            • <strong>{i18n.__('inbox.escrow.about')}</strong>
          </p>
          <p>
            • <strong>{i18n.__('inbox.deposit.about')}</strong>
          </p>
          <p>
            {i18n.__('inbox.autoClear')}
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default InboxPage;
